import { onBeforeUnmount, ShallowRef } from 'vue';
import { Tooltip } from 'floating-vue';

const OVERLAY_SELECTOR =
  '[data-scope="popover"][data-part="content"], [role="dialog"]';

// ツールチップの中から開くメニュー・モーダルはbody直下にteleportされ、ツールチップの外側の扱いになる。
// 開いている間はマウスが離れてもツールチップを閉じず、閉じられた後に改めて閉じるか判定する
export const useTooltipOverlayGuard = (
  tooltip: Readonly<ShallowRef<InstanceType<typeof Tooltip> | null>>,
  trigger: Readonly<ShallowRef<HTMLElement | null>>,
  popperContent: Readonly<ShallowRef<HTMLElement | null>>,
) => {
  let overlayObserver: MutationObserver | undefined;

  const hasOpenOverlay = () => !!document.querySelector(OVERLAY_SELECTOR);

  const isHovered = () =>
    !!trigger.value?.matches(':hover') ||
    !!popperContent.value?.closest('.v-popper__popper')?.matches(':hover');

  const stopObserving = () => {
    overlayObserver?.disconnect();
    overlayObserver = undefined;
  };

  const hideAfterOverlayCloses = () => {
    if (overlayObserver) return;
    overlayObserver = new MutationObserver(() => {
      if (hasOpenOverlay()) return;
      stopObserving();
      if (!isHovered()) tooltip.value?.hide();
    });
    overlayObserver.observe(document.body, { childList: true, subtree: true });
  };

  const onHide = () => {
    if (!hasOpenOverlay()) return;
    tooltip.value?.show({ skipDelay: true });
    hideAfterOverlayCloses();
  };

  onBeforeUnmount(stopObserving);

  return { onHide };
};
